import lf from "localforage";

async function dbInit() {
  return {
    async add(store, data) {
      let list = await lf.getItem(store);
      if (!list) list = [];
      list.push(data);
      await lf.setItem(store, list);
    },
    async addBatch(store, data) {
      if (data && Array.isArray(data) && data.length) {
        let list = await lf.getItem(store);
        if (!list) list = [];
        await lf.setItem(store, [...list, ...data]);
      }
    },
    async get(store, id) {
      let list = await lf.getItem(store);
      if (list && list.length) return list.find(ls => ls.id === id);
      else return null;
    },
    async getAll(store) {
      let list = await lf.getItem(store);
      return list || [];
    }
  };
}

function MensajesDB() {
  let storeName = "mensajes";

  return {
    async createOne(data) {
      const db = await dbInit();
      await db.add(storeName, data);
    },
    async createMany(datas) {
      const db = await dbInit();
      if (datas && Array.isArray(datas)) {
        await db.addBatch(storeName, datas);
      }
    },

    async readOne(id) {
      const db = await dbInit();
      const vari = await db.get(storeName, id);
      return vari;
    },
    async read(query) {
      const db = await dbInit();
      if (query && Array.isArray(query) && query.length) {
        const results = [];
        let filter = await db.getAll(storeName);
        for (const cursor of filter) {
          let element = null;
          let pureVal = cursor;
          for (const qu of query) {
            if (qu.type === "where") {
              if (qu.field && pureVal[qu.field]) {
                switch (qu.op) {
                  case "===":
                  case "==":
                    if (pureVal[qu.field] === qu.value) element = pureVal;
                    break;

                  default:
                    break;
                }
              }
            }
          }
          if (element) results.push(element);
        }
        return results;
      } else {
        const vari = await db.getAll(storeName);
        return vari;
      }
    }
  };
}

export default { MensajesDB };
